function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Video_Lesson",
  "data-name": "Video Lesson",
  transform: "translate(-852.25 -334.25)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_172",
  "data-name": "Path 172",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "M1,1.751,7.752,0A.558.558,0,0,1,8.3.563V9.006a.558.558,0,0,1-.552.563L1,7.818a1.21,1.21,0,0,1-.85-.867V2.618A1.21,1.21,0,0,1,1,1.751Z",
  transform: "translate(870.696 337.6)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_173",
  "data-name": "Path 173",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "M2.693,0H17.157a1.738,1.738,0,0,1,1.693,1.779V13.821A1.738,1.738,0,0,1,17.157,15.6H2.693A1.738,1.738,0,0,1,1,13.821V1.779A1.738,1.738,0,0,1,2.693,0Z",
  transform: "translate(852 335)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_55",
  "data-name": "Ellipse 55",
  fill: "currentColor",
  cx: 1.7,
  cy: 1.7,
  r: 1.7,
  transform: "translate(864.9 337.6)"
}));

var SvgVideoLesson = function SvgVideoLesson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27.5 17.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoLesson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video-lesson.c05a5084.svg";
export { ForwardRef as ReactComponent };